import { FundriseRouteConfig } from 'vue-router';
import { getWebsiteDocument } from '@api/website-document';

const documentRedirectRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/website-documents/:title',
		name: 'website-document-view',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to) => {
			const title = to.params.title as string;
			try {
				const redirectLink = await getWebsiteDocument(title);
				window.location.href = redirectLink.redirectUrl;
			} catch {
				return { name: '404', replace: true };
			}
		},
		// revisit using redirect
		component: () => import('@views/marketing-site/home-view.vue')
	}
];

export default documentRedirectRoutes;
